import Vue from 'vue'
import { Logger } from "aws-amplify"
//import moment from "moment"
const logger = new Logger("$store/presence/mutations") 

export default {
  setVehicleStatus: (state, item) => {
    Vue.set(state.vehicleStatus, item.VehicleID, item.status)
  },

  // updates the device info with details sent in the presence websocket events
  updateDevicePresence: (state, device) => {
    if(!state.selectedOrg) {
      logger.debug('no active org to set vehicles')
    }

    if(!state.devicesMapData[state.selectedOrg]) {
      Vue.set(state.devicesMapData, state.selectedOrg,  {})
    }

    if(!state.vehicleStatusData[state.selectedOrg]) {
      Vue.set(state.vehicleStatusData, state.selectedOrg,  {})
    }

    /* todo fix out of order!
    // if we already have some state for this device, we check here to see if the last seen time is more up to date that what we already have. 
    if(state.devicesMapData[state.selectedOrg][device.id]) {
        const currentLastSeen = moment(state.devicesMapData[state.selectedOrg][device.id].data.last_seen).valueOf()
        const newLastSeen = moment(device.data.last_seen).valueOf()
        if(currentLastSeen > newLastSeen) {
            logger.debug("pres update is older than current")
            return
        }
    }
    */

    state.mapUpdatesToSend = true
    Vue.set(state.devicesMapData[state.selectedOrg], device.id, device)
    Vue.set(state.vehicleStatusData[state.selectedOrg], device.vehicle_id, device.statusText)
  },

  setVehicles: (state, vehicles) => {
    if(!state.selectedOrg) {
      logger.debug('no active org to set vehicles')
    }

    Vue.set(state.vehicles, state.selectedOrg, vehicles)
  },

  resetPresence: (state) => {
    state.devicesMapData = {}
    state.vehicleStatusData = {}
  },

  setOrgToWatch: (state, org) => {
    state.selectedOrg = org
  }
}